<template>
    <div class="button-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>

<script>
export default {
    name: "LoaderEditProfile"
}
</script>

<style>
.button-ring,
.button-ring div {
    box-sizing: border-box;
}

.button-ring {
    display: inline-block;
    position: relative;
    width: 14px;
    height: 14px;
}

.button-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 14px;
    height: 14px;
    margin: 2px;
    border: 2px solid #888;
    border-radius: 50%;
    animation: button-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #888 transparent transparent transparent;
}

.button-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.button-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.button-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes button-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
